class HeroCarousel extends window.BAO.CustomElement() {

  connectedCallback () {
    super.connectedCallback()

    this.heroCarouselSetup()
  }

  setupListeners () {
    super.setupListeners()

    this.heroCarouselSetup = this.heroCarouselSetup.bind(this)
  }

  // Set up the carousel
  async heroCarouselSetup () {
    const heroCarouselContainer = this.els['hero-slider']?.element

    if (heroCarouselContainer) {
      this.setupCarousel(
        heroCarouselContainer,
        this.els['hero-slider-prev']?.element,
        this.els['hero-slider-next']?.element,
        heroCarouselContainer.dataset.heroCarouselSpeed,
        heroCarouselContainer.dataset.heroCarouselAutoplay
      )
    }
  }

  // Set up the KeenSlider carousel
  setupCarousel (slidesEl, prevEl, nextEl, speed, autoplayBool) {
    return new window.KeenSlider(
      slidesEl,
      {
        selector: '.sec-Carousel_Slide',
        defaultAnimation: {
          duration: 1500,
        },
        loop: autoplayBool,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: '1',
          spacing: 0,
        },
      },
      [
        window.BAO.carousel.useInitialised(),
        window.BAO.carousel.useArrows({
          next: nextEl,
          previous: prevEl,
        }),
        window.BAO.carousel.useDots(this.els?.dot?.elements),
        window.BAO.carousel.useAutoplay(speed, { pauseOnHover: false }, autoplayBool)
      ]
    )
  }
}

if (!customElements.get('hero-carousel')) {
  customElements.define('hero-carousel', HeroCarousel)
}